var _defs, _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgModelOnMap(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n      }\n\n      .cls-2 {\n        fill: #8e8e98;\n      }\n\n      .cls-3 {\n        fill: #ccc;\n      }\n\n      .cls-4 {\n        fill: #363c4f;\n      }\n    "))), /*#__PURE__*/React.createElement("g", {
    style: {
      visibility: "hidden"
    },
    id: "Layer_2",
    "data-name": "Layer 2"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    width: 32,
    height: 32
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Outlines"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M27,8.5v15.5c.42-.31,.93-.5,1.5-.5,1.38,0,2.5,1.12,2.5,2.5s-1.12,2.5-2.5,2.5H3.5c-1.38,0-2.5-1.12-2.5-2.5s1.12-2.5,2.5-2.5c.57,0,1.08,.19,1.5,.5V8.5H27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1,26V6c0-1.38,1.12-2.5,2.5-2.5,.57,0,1.08,.19,1.5,.5V24c-.42-.31-.93-.5-1.5-.5-1.38,0-2.5,1.12-2.5,2.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M31,26c0-1.38-1.12-2.5-2.5-2.5-.57,0-1.08,.19-1.5,.5V4c.42-.31,.93-.5,1.5-.5,1.38,0,2.5,1.12,2.5,2.5V26Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 30.5,
    y: 6,
    width: 1,
    height: 20
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M28.5,29H3.5c-1.65,0-3-1.35-3-3V6c0-1.65,1.35-3,3-3,.66,0,1.28,.21,1.8,.6l.2,.15V25.01l-.8-.61c-.34-.26-.76-.4-1.2-.4-1.1,0-2,.9-2,2s.9,2,2,2H28.5c1.1,0,2-.9,2-2s-.9-2-2-2c-.44,0-.85,.14-1.2,.4l-.8,.61V3.75l.2-.15c.52-.39,1.14-.6,1.8-.6,1.65,0,3,1.35,3,3h-1c0-1.1-.9-2-2-2-.36,0-.7,.09-1,.27V23.17c.32-.11,.65-.17,1-.17,1.65,0,3,1.35,3,3s-1.35,3-3,3ZM3.5,4c-1.1,0-2,.9-2,2V23.77c.77-.69,1.98-.96,3-.6V4.27c-.3-.17-.64-.27-1-.27Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 7,
    y: 8,
    width: 18,
    height: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "17 24.82 17 17.83 9.68 15.84 9.68 22.83 17 24.82"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "17 24.82 17 17.83 22.32 14.17 22.32 21.16 17 24.82"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "22.32 14.17 17 17.83 9.68 15.84 15 12.18 22.32 14.17"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "17.09 18.38 9.55 16.32 9.81 15.36 16.91 17.29 22.04 13.76 22.61 14.59 17.09 18.38"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M17.09,25.37l-7.91-2.16v-7.63l5.73-3.94,7.91,2.16v7.63l-5.73,3.94Zm-6.91-2.92l6.73,1.84,4.92-3.38v-6.34l-6.73-1.84-4.92,3.38v6.34Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 16.5,
    y: 17.83,
    width: 1,
    height: 6.99
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgModelOnMap);
export default __webpack_public_path__ + "static/media/ModelOnMap.cae8b1e2fa4a32274211df0ee560cddd.svg";
export { ForwardRef as ReactComponent };